import React from "react";
import MobileNav from "./MobileNav";
import PcNav from "./PcNav";
import CheckWidth from "../CheckWidht";

const navNames = [
  { id: 1, name: "Umów wizytę", to: "black_bgc" },
  { id: 2, name: "Usługi", to: "services" },
  { id: 3, name: "Galeria", to: "App .slider_box" },
  { id: 4, name: "Kontakt", to: "contact" },
];

const MainNav = () => {
  return CheckWidth() < 1366 ? (
    <MobileNav navNames={navNames} />
  ) : (
    <PcNav navNames={navNames} />
  );

  //   return isMobile ? <MobileNav/> : <PcNav />;
};

export default MainNav;
